import { Link } from 'react-router-dom'
import { Home, Search, Bike } from 'lucide-react'

export function NotFoundPage() {
  return (
    <div className="max-w-[720px] mx-auto px-6 py-16 text-center">
      <div className="relative inline-block">
        <div className="text-[140px] leading-none font-black text-brand-100 select-none">404</div>
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-20 h-20 rounded-full bg-brand-600 flex items-center justify-center text-white shadow-hover">
            <Bike className="w-10 h-10" />
          </div>
        </div>
      </div>

      <h1 className="text-2xl lg:text-3xl font-bold text-text mt-4">Không tìm thấy trang</h1>
      <p className="text-muted mt-2">
        Trang bạn đang tìm không tồn tại, đã bị di chuyển hoặc đường dẫn không hợp lệ.
      </p>

      <div className="mt-8 flex items-center justify-center gap-3 flex-wrap">
        <Link
          to="/"
          className="h-11 px-6 rounded-md bg-brand-600 hover:bg-brand-700 text-white font-semibold text-sm inline-flex items-center gap-2 transition"
        >
          <Home className="w-4 h-4" /> Về trang chủ
        </Link>
        <Link
          to="/danh-muc/xe-may-dien"
          className="h-11 px-6 rounded-md border border-border text-text hover:bg-slate-50 font-medium text-sm inline-flex items-center gap-2 transition"
        >
          <Search className="w-4 h-4" /> Xem sản phẩm
        </Link>
      </div>
    </div>
  )
}
